const required = { required: true, message: 'This is a required field' }
const requiredRule = [required]

export { requiredRule }
